import React from 'react';
import Header from '../common/header';

import Footer from '../common/footer';
import WebinarPageHeader from '../layout/webinar/webinarPageHeader';
import WebinarMain from '../layout/webinar/webinarMain';



function Webinar(){
    return(
        <>
        <Header/>
        
      <WebinarMain></WebinarMain>
        <br/>
        <Footer/>
        </>
    )
}
export default Webinar;